'use client';

import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';
import Link from 'next/link';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-6 py-12 text-center font-sans">
          <div className="p-5 rounded-2xl bg-red-50 mb-6">
            <AlertTriangle size={40} className="text-red-500 mx-auto" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Something went wrong</h1>
          <p className="text-sm text-slate-500 max-w-sm mb-1">
            An unexpected error occurred. Your data is safe — please try refreshing the page.
          </p>
          {error.digest && (
            <p className="text-xs text-slate-400 mb-6 font-mono">Error ID: {error.digest}</p>
          )}
          <div className="flex items-center gap-3 mt-4">
            <button
              onClick={reset}
              className="flex items-center gap-2 px-5 py-2.5 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold"
            >
              <RefreshCw size={14} />
              Try Again
            </button>
            <Link
              href="/"
              className="flex items-center gap-2 px-5 py-2.5 text-sm border border-slate-200 rounded-lg hover:bg-slate-100 transition-colors text-slate-700"
            >
              <Home size={14} />
              Go Home
            </Link>
          </div>
        </div>
      </body>
    </html>
  );
}
